import { useContext, useRef } from 'react';
import { isArray, isNotUndefined } from '@wistia/type-guards';
import { Link } from '../Link';
import { FormContext } from './Form';

type ErrorItemProps = {
  name: string;
  error: string;
  formId: string;
};

const ErrorItem = ({ name, error, formId }: ErrorItemProps) => {
  return (
    <li key={name}>
      <Link href={`#${formId}-${name}`}>{error}</Link>
    </li>
  );
};

export type FormErrorSummaryProps = {
  /** A description to show before the list of form errors */
  description: string;
};

export const FormErrorSummary = ({ description }: FormErrorSummaryProps) => {
  const ref = useRef(null);
  const { formId, errors, hasSubmitted } = useContext(FormContext);
  const isValid = Object.keys(errors).length === 0;

  if (isValid || !hasSubmitted) {
    return null;
  }

  return (
    <div ref={ref}>
      <p>{description}</p>
      <ul>
        {Object.entries(errors)
          .filter(([, error]) => isNotUndefined(error))
          .map(([name, error]) =>
            isArray(error) ? (
              error.map((err) => (
                <ErrorItem
                  key={err}
                  error={err}
                  formId={formId}
                  name={name}
                />
              ))
            ) : (
              <ErrorItem
                key={error}
                error={error ?? ''}
                formId={formId}
                name={name}
              />
            ),
          )}
      </ul>
    </div>
  );
};
